let inject = [
  '$scope',
  'routinesDetailService',
  '$state',
  '$rootScope',
  '$timeout',
  'SessionService'
];

class RoutinesDetailController {
  constructor($scope, routinesDetailService, $state, $rootScope, $timeout,SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.routinesDetailService = routinesDetailService;
    this.activities = [];
	this.SessionService = SessionService;

  }

  $onInit() {
	  this.shCtrl.activate();
    this.userId = this.shCtrl.globals.currentUser.userId;
    this.filter = {};
	this.cacheFilter = {
		firtsConsulta : true
	};
    
    this.currentPage = 1;
	this.currentPageCache = 0;
    this.getActivities();
    
    this.totalItems = 0;
    this.totalPages = 1;
	
	this.ultimaActualizacion = '';

  }

  getActivities() {
	if(!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache) {
		this.currentPageCache = angular.copy(this.currentPage);
		this.cacheFilter = angular.copy(this.filter);
		this.loading = true;
		this.error = false;
		this.errorMsg = '';
		
		this.data = {
					'userId' : this.userId,
					'pageNumber' : (this.currentPage) ? this.currentPage : 1,
					'pageSize' : 20,
					'filter' : this.filter,
					'consulta' : 'detalleRutina',
					'id'	   : this.id
					};
					
		this.routinesDetailService.getActivitiesData(this.data).then(response => {
			this.loading = false;

			if(response.error) {
				this.error = true;
				this.errorMsg = response.mensaje;
			}else {				
				this.activities = response.actividades;
				this.totalItems = response.totalItems;
				this.totalPages = response.totalPage;
				this.ultimaActualizacion = response.ultimaActualizacion;
			}
			if((this.error || !this.activities.length) && this.errorMsg == '') {
					this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
			}
		}).catch(reason => {
			this.loading = false;
			this.error = true;
			
			if(this.error && this.errorMsg == '') {
				this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
			}
		});
	}
  }
  
   exportarXls(id) {
	  this.exportLoading2 = true;
	  

	  let data = {
		  'pageNumber' : 1,
		  'pageSize' : this.totalItems,
		  'userId' : this.userId,
		  'consulta' : 'detalleRutina',
		  'filter' : this.filter,
		  'id'	   : this.id,
		  'rut'		: this.rut
	  };
	  this.routinesDetailService.exportarXls(data).then(response => {
		
		this.exportLoading2 = false;
        let ruta = response.split('/');
		
		var link = document.getElementById("labelprueba");
        link.setAttribute("href", response);
        link.setAttribute("download", ruta[ruta.length - 1]);
        link.click();
    }).catch(reason => {
		$this.exportLoading2 = false;
	});
  }
  
   exportarPdf() {
	  this.exportLoading = true;
	  

	  let data = {
		  'userId' : this.userId,
		  'tipoDoc' : 'detalleRutina',
		  'id' : this.id,
		  'nombreDocumento' : this.rut,
	  };
	  this.routinesDetailService.exportarPdf(data).then(response => {
		
		this.exportLoading = false;
        let ruta = response.split('/');
		
		var link = document.getElementById("labelprueba");
        link.setAttribute("href", response);
        link.setAttribute("download", ruta[ruta.length - 1]);
        link.click();
    }).catch(reason => {
		$this.exportLoading = false;
	});
  }

}

RoutinesDetailController.$inject = inject;

export default RoutinesDetailController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-detail/routines-detail.controller.js
 **/